import { render } from "./SabreJrEnhanced.vue?vue&type=template&id=b74bc5a6&scoped=true"
import script from "./SabreJrEnhanced.vue?vue&type=script&lang=js"
export * from "./SabreJrEnhanced.vue?vue&type=script&lang=js"

import "./SabreJrEnhanced.vue?vue&type=style&index=0&id=b74bc5a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74bc5a6"]])

export default __exports__